import { Button } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

import { LinearLoading } from 'common'
import { LegalDepositTable } from './LegalDepositTable'
import { ModalModule } from './MoldaDeposit'


const LegalFormStepDeposit = ({useFetchInit}) => {

    const {
        globalStates,
        FetchData,
        Actions
    } = useFetchInit

    const { stepApplilication } = globalStates

    const { fetchAllDeposits } = FetchData
    const { loadingFetchDeposits } = fetchAllDeposits

    const { handleClickReturnStep, handleClickNextStep } = Actions

    return (
        <>
            
            {loadingFetchDeposits && ( <LinearLoading /> )}
            <LegalDepositTable
                useFetchInit = {useFetchInit}
            />

            <ModalModule useFetchInit={useFetchInit} />
            <div className="text-center">
                {stepApplilication !== 0 && (
                    <Button 
                        startIcon={<ArrowLeftCircle/>}
                        variant="contained"
                        type="button"
                        onClick={handleClickReturnStep} 
                        sx={{ marginRight: 1, marginLeft: 1, background: "#ef8157" }}
                    >
                        Volver
                    </Button>
                )}
                <Button
                    endIcon={<ArrowRightCircle/>}
                    variant="contained"
                    type="button"
                    style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                    onClick={handleClickNextStep}
                >       
                    {stepApplilication === 4 ? 'Finalizar' : 'Continuar'}
                </Button>
            </div>
        </>
    )


}
export {
    LegalFormStepDeposit
}